export default __webpack_public_path__ + "static/media/c006-6.4136e353.gif";